module.exports = __webpack_public_path__ + "static/media/samuel.96b54ecd.jpg";